import IBus from "@/lib/Bus"; 

import mqtt from "paho-mqtt"
import { ObjEvents } from "../../server/src/mqtt/ObjEvents"


export class MqttClient {

    options:any={useSSL:true, timeout:3, onSuccess: this.onConnect.bind(this)}
    client:any=null
    connected_flag:any=null
    //port:number=443
    broker:string="dev.e-grafpol.pl"

    constructor(public bus: IBus) {
        this.bus = bus
    }

    onConnect() {
        //console.log("MQTT connected")
        
        this.client.subscribe(ObjEvents.event_insert); 
        this.client.subscribe(ObjEvents.event_update); 
        this.client.subscribe(ObjEvents.event_delete); 
        this.client.subscribe(ObjEvents.status_changed); 
        this.client.subscribe(ObjEvents.list_status_changed); 
        this.client.subscribe("/GRAFLOW/LICZNIK/+"); 
        
        this.client.subscribe(ObjEvents.event_path_open); 
        this.client.subscribe(ObjEvents.event_path_close_request); 

        this.connected_flag=1;
        //bus.call('/api/mqtt/get_messages',{})
    }

    connect() {
        //console.log("MQTT connecting ...")
        // @ts-ignore
        this.client = new mqtt.Client(this.broker, 443, '/mqtt',"graflow_firefox" + new Date().getTime());
        this.client.onConnectionLost = this.onConnectionLost.bind(this);
        this.client.onMessageArrived = this.onMessageArrived.bind(this);
        this.connected_flag=0;
        this.client.connect(this.options);
    }

    async onMessageArrived(msg:any) {
        let obj = msg.payloadString
        obj=JSON.parse(msg.payloadString)
        obj.mqtt_topic = msg.topic
        console.log(msg.topic,msg.payloadString)
        this.bus.fire(msg.topic, obj);
        if (msg.topic == ObjEvents.event_path_open) {
            //this.bus.check_concurrency(obj)
            await this.bus.send_close_request(obj)
        }
        if (msg.topic == ObjEvents.event_path_close_request) {
            this.bus.process_close_request(obj)
        }
    }

    onConnectionLost() {
        //console.log("MQTT connection lost")
        this.connected_flag=0;
        this.connect();
    }

    async publish(dest:any, msg:string)  {
        if (  this.connected_flag==1 ) {
            // @ts-ignore
            /*
            const message = new Paho.MQTT.Message(msg);
            message.destinationName = dest;
            await this.client.send(message);
            */
            console.log("publish", dest, msg)
            await this.client.publish(dest, msg);
        } else {
            console.log("publish: not connected")
        }
    }

}